var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneycreditcard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "moneycredit card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 19.033H21.5C21.8977 19.0323 22.2789 18.8341 22.5601 18.4818C22.8413 18.1296 22.9995 17.652 23 17.1538V10.5V9V5.87912C22.999 5.38114 22.8406 4.90391 22.5595 4.55178C22.2785 4.19965 21.8975 4.00127 21.5 4H3.5C3.10249 4.00127 2.72154 4.19965 2.44046 4.55178C2.15937 4.90391 2.00101 5.38114 2 5.87912V9V10.5V17.1538C2.00101 17.6518 2.15937 18.129 2.44046 18.4812C2.72154 18.8333 3.10249 19.0317 3.5 19.033ZM3.5 10.5V17.5307H21.5V10.5H3.5ZM3.5 9H21.5V5.49691H3.5V9ZM20.25 15H15V16.5H20.25V15Z",
    fill: "#050A25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneycreditcard);
export default __webpack_public_path__ + "static/media/moneycredit card.667f1ccd97ea6d415700733213c12c3f.svg";
export { ForwardRef as ReactComponent };